<div class="documentAuditSection">
<app-document-audit-life-cycle
  *ngIf="isDocumentAuditDetailsDataLoaded"
  [auditLifecycleInput]="documentLifeCycleDetails"
>
</app-document-audit-life-cycle>
<p-fieldset legend="Audit Trail" *ngIf="isDocumentAuditDetailsDataLoaded">
  <div class="grid">
    <div class="col-6">
      <app-document-audit-summary
        [auditSummaryDetails]="documentAuditSummaryDetails"
        (attributeDetailsOfTransaction)="showAuditItemDetails($event)"
      ></app-document-audit-summary>
    </div>
    <div class="col-6 auditTrialDetailsSection">
      <app-audit-item-details
        [auditTrialDetails]="auditAttributeDetailsOfTransaction"
      ></app-audit-item-details>
    </div>
  </div>
</p-fieldset>
</div>
